export const TARIFF_LOADING = "charger/tariff/TARIFF_LOADING";
export const TARIFF_ERROR = "charger/tariff/TARIFF_ERROR";
export const TARIFF_GET_LIST = "charger/tariff/TARIFF_GET_LIST";
export const TARIFF_RESET_LIST = "charger/tariff/TARIFF_RESET_LIST";
export const TARIFF_ADD = "charger/tariff/TARIFF_ADD";
export const TARIFF_ADD_IMAGE = "charger/tariff/TARIFF_ADD_IMAGE";
export const TARIFF_GET_IMAGE = "charger/tariff/TARIFF_GET_IMAGE";



// WEBPACK FOOTER //
// ./src/actions/chargers/tariff/constants.js